import { graphql, fetchQuery, useRelayEnvironment } from 'react-relay';
import { lang } from '@/helpers/translate';
import { debounceFunction } from '@/helpers/common';

// Réutilise la même query que bypattern.js
const AutocompletionQuery = graphql`
  query usePatternAutocompleteQuery($pattern: String, $lang: [String]) {
    elastic{ res: autocompletion(input:{pattern: $pattern, lang: $lang })}
  }
`;

export function usePatternAutocomplete() {
  const environment = useRelayEnvironment();
  const langCurrent = lang();

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      return callback([]);
    }
    fetchQuery(environment, AutocompletionQuery, {
      pattern: inputValue,
      lang: [langCurrent],
    }).subscribe({
      next: (data1) => {
        if (data1?.elastic?.res?.code === 200) {
          callback(data1?.elastic?.res?.res?.map((kw) => ({
            label: kw,
            value: kw,
          })) || []);
        } else {
          callback([]);
        }
      },
      error: () => {
        callback([]);
      },
    });
  };

  const debouncedLoadOptions = debounceFunction((inputValue, callback) => {
    loadOptions(inputValue, callback);
  }, 300);

  return {
    loadOptions: debouncedLoadOptions,
  };
}

export default usePatternAutocomplete;
